export const MAX_USE_TICKETS = "maxUseTickets";
export const MAX_USE_AMOUNT = "maxUseAmount";
export const DELETED = "DELETED";
export const TERMINATED = "TERMINATED";